<div [formGroup]="holdNeededDateForm" class="hold-needed-date">
  <div class="hold-needed-date__input">
    <div class="w-100">
      <label
        for="needed-from-date"
        data-automation-id="needed-from-date-label"
        class="hold-needed-date__label"
      >
        {{ "notNeededAfter" | translate }}
      </label>
      <div class="form-group form-inline">
        <div class="input-group">
          <div class="input-group-prepend">
            <button
              type="button"
              class="btn btn-outline-flint"
              (click)="pickerNeededFrom.open()"
              attr.aria-label="{{ 'calendarNeededFrom' | translate }}"
              data-automation-id="toggle-datepicker-from"
            >
              <fa-icon [icon]="calendarIcon"></fa-icon>
            </button>
          </div>
          <input
            class="form-control"
            id="needed-from-date"
            [matDatepicker]="pickerNeededFrom"
            [min]="today"
            formControlName="neededFrom"
            [class.is-invalid]="holdNeededDateForm.get('neededFrom')?.invalid"
            data-automation-id="needed-from-date"
            attr.aria-label="{{ 'neededFrom' | translate }}"
          />
          <mat-datepicker #pickerNeededFrom color="accent"></mat-datepicker>
        </div>
      </div>
      <div class="hold-needed-date__input__date-format">{{ dateFormat }}</div>
    </div>
  </div>
</div>
